import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

export const runReport = async (
  id: number,
  start: Date,
  end: Date,
  interval: number,
  timezone: string,
  decimals: number,
) => {
  await authFetch(
    `${API_BASE}/reports/${id}/run?start=${start.toISOString()}&end=${end.toISOString()}&interval=${interval}&timezone=${timezone}&decimals=${decimals}`,
    {
      method: "POST",
    },
  )
}
